<form nz-form [formGroup]="filterForm">

  <div nz-row gutter="16"
    style="display: flex; flex-wrap: wrap; align-items: flex-end; width: 100%;justify-content: flex-end;">

    <!-- Help: opens the "How to use" guide -->
    <div nz-col>
      <nz-form-item>
        <button type="button" class="help-icon-button" aria-label="How to use this dashboard"
          title="How to use this dashboard" (click)="openHelpModal()">
          <i class="fa fa-info-circle" aria-hidden="true"></i>
        </button>
      </nz-form-item>
    </div>

    <!-- Filter Items -->

    <div nz-col [nzXs]="24" [nzSm]="12" [nzMd]="8" [nzLg]="4" [nzXl]="3" [nzXXl]="3"
      style="margin-left: 8px;">
      <nz-form-item>
        <nz-form-control [nzErrorTip]="'Please select a From Date'">
          <nz-date-picker formControlName="fromDate" id="fromDate" [nzFormat]="'MM/dd/yyyy'"
            [nzPlaceHolder]="'From Date'" [nzDisabledDate]="disableFromDate" style="width: 100%;"></nz-date-picker>
        </nz-form-control>
      </nz-form-item>
    </div>

    <div nz-col [nzXs]="24" [nzSm]="12" [nzMd]="8" [nzLg]="4" [nzXl]="3" [nzXXl]="3"
      style="margin-left: 8px;">
      <nz-form-item>
        <nz-form-control [nzErrorTip]="toDateError">
          <nz-date-picker formControlName="toDate" id="toDate" [nzFormat]="'MM/dd/yyyy'"
            [nzPlaceHolder]="'To Date'" [nzDisabledDate]="disableToDate" style="width: 100%;"></nz-date-picker>
          <ng-template #toDateError let-control>
            @if (control.hasError('required')) {
            Please select a To Date
            } @else if (control.hasError('beforeFromDate')) {
            To Date can't be before From Date
            }
          </ng-template>
        </nz-form-control>
      </nz-form-item>
    </div>

    <div nz-col [nzXs]="24" [nzSm]="12" [nzMd]="8" [nzLg]="4" [nzXl]="3" [nzXXl]="3"
      style="margin-left: 8px;">
      <nz-form-item>
        <nz-form-control [nzErrorTip]="'Please select a Spending Plan'">
          <nz-select formControlName="spendingPlan" class="filters" id="spendingPlan" nzPlaceHolder="Spending Plan"
            nzShowSearch nzAllowClear style="width: 100%;">
            @for(opt of authorizations; track $index) {
            <nz-option [nzLabel]="opt.clientAuth" [nzValue]="opt.clientAuth"></nz-option>
            }
          </nz-select>
        </nz-form-control>
      </nz-form-item>
    </div>

    <!-- Provider gets an extra column: its options carry a full name plus a PPL ID. -->
    <div nz-col [nzXs]="24" [nzSm]="12" [nzMd]="8" [nzLg]="5" [nzXl]="4" [nzXXl]="4"
      style="margin-left: 8px;">
      <nz-form-item>
        <nz-form-control [nzErrorTip]="'Please select a Provider'">
          <nz-select formControlName="providerId" class="filters" id="providerId" nzPlaceHolder="Provider" nzShowSearch
            nzAllowClear [nzOptionHeightPx]="48" style="width: 100%;">
            @for(opt of providers; track $index) {
            <!-- nzLabel still drives search and the selected text; the list shows name over PPL ID. -->
            <nz-option nzCustomContent [nzLabel]="opt.providerFullName + ' - ' + opt.providerPplId"
              [nzValue]="opt.providerId">
              <div class="provider-option">
                <span class="provider-option-name">{{ opt.providerFullName }}</span>
                <span class="provider-option-id">{{ opt.providerPplId }}</span>
              </div>
            </nz-option>
            }
          </nz-select>
        </nz-form-control>
      </nz-form-item>
    </div>

    <div nz-col [nzXs]="24" [nzSm]="12" [nzMd]="8" [nzLg]="4" [nzXl]="3" [nzXXl]="3"
      style="margin-left: 8px;">
      <nz-form-item>
        <nz-form-control [nzErrorTip]="'Please select a Category'">
          <nz-select formControlName="serviceGroupLkp" class="filters" id="serviceGroupLkp" nzPlaceHolder="Category"
            nzShowSearch nzAllowClear style="width: 100%;">
            @for(opt of serviceGroups; track $index) {
            <nz-option [nzLabel]="opt.lkpValueName" [nzValue]="opt.lkpValueName"></nz-option>
            }
          </nz-select>
        </nz-form-control>
      </nz-form-item>
    </div>

    <!-- Service Code gets an extra column too: its options are full service descriptions. -->
    <div nz-col [nzXs]="24" [nzSm]="12" [nzMd]="8" [nzLg]="5" [nzXl]="4" [nzXXl]="4"
      style="margin-left: 8px;">
      <nz-form-item>
        <nz-form-control [nzErrorTip]="'Please select a Service Code'">
          <nz-select formControlName="serviceCodeLkp" class="filters" id="serviceCodeLkp" nzPlaceHolder="Service Code"
            nzShowSearch nzAllowClear style="width: 100%;">
            @for(opt of serviceCodesList; track $index) {
            <nz-option [nzLabel]="opt.description" [nzValue]="opt.code"></nz-option>
            }
          </nz-select>
        </nz-form-control>
      </nz-form-item>
    </div>

    <!-- Search Button (Always aligned right) -->
    <div class="spending-plan-buttons" nz-col style="margin-left: 8px;">
      <nz-form-item>
        <ppl-button label="Apply Filter" icon="fa fa-filter" [styleString]="'margin-top: -2px;'" [customClass]="'ghost-button'"
          [iconPosition]="'left'" (click)="onFilterApply()"></ppl-button>

        <ppl-button label="Reset Filters" icon="fa fa-refresh" [styleString]="'margin-top: -2px; margin-left: 8px;'"
          [customClass]="'ghost-button'" [iconPosition]="'left'" (click)="onResetFilters()"></ppl-button>
      </nz-form-item>
    </div>
  </div>
</form>

<div class="applied-filters" aria-live="polite">
  <span class="applied-filters-title">Showing results for:</span>
  <span class="applied-filter-chip">
    <span class="applied-filter-label">Dates</span>
    {{ fromDate | date: 'MM/dd/yyyy' }} - {{ toDate | date: 'MM/dd/yyyy' }}
  </span>
  @for (chip of appliedFilterChips; track chip.label) {
  <span class="applied-filter-chip">
    <span class="applied-filter-label">{{ chip.label }}</span>
    {{ chip.value }}
  </span>
  }
</div>

<ppl-spending-plan-overview [overallBudgetSummary]="totalBudget" [spentCurrentMonth]="spentCurrentMonth"
  [categoryBreakdown]="categoryBreakdown" [noAllocation]="noAuthAllocation"
  (categorySelect)="onCategorySelect($event)"
  (allDetailsSelect)="onAllDetailsSelect()"></ppl-spending-plan-overview>

<div class="filter-panel">
  <ng-template #spendingPlanDetailSummary let-cancel="cancel">
    <div class="p-4">
      <ppl-spending-plan-detailed-summary [chartSummary]="chartSummary"></ppl-spending-plan-detailed-summary>
    </div>
  </ng-template>

  <ng-template #spendingDashboardHelp>
    <div class="p-4">
      <ppl-spending-dashboard-help></ppl-spending-dashboard-help>
    </div>
  </ng-template>
</div>